(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    'use strict';

    /* ---------------------------------------------------------------- *
     * K4 — modo navegacao discreta.
     * O estado ja foi aplicado antes da primeira pintura pelo script
     * inline do <head> (o `window.tdDiscreet`). Aqui e so o interruptor.
     * Se aquele script nao existir (item desligado no editor), este bloco
     * nao faz nada e o botao continua escondido.
     * ---------------------------------------------------------------- */
    var CHAVE_DISCRETA = 'td-discreet';

    function lerDiscreta() {
      try {
        return localStorage.getItem(CHAVE_DISCRETA) === '1';
      } catch (e) {
        return false;
      }
    }

    function ligarDiscreta() {
      if (!window.tdDiscreet) return;
      var botoes = document.querySelectorAll('[data-td-discreet]');
      if (!botoes.length) return;

      var estado = lerDiscreta();
      botoes.forEach(function (botao) {
        /* Revelar o botao e a PRIMEIRA coisa: ate aqui ele estava escondido
           justamente porque nada garantia que o script chegaria. */
        botao.hidden = false;
        botao.setAttribute('aria-pressed', estado ? 'true' : 'false');
      });

      if (document.documentElement.dataset.tdDiscreetOn === 'yes') return;
      document.documentElement.dataset.tdDiscreetOn = 'yes';

      document.addEventListener('click', function (evento) {
        var botao = evento.target.closest('[data-td-discreet]');
        if (!botao) return;
        var novo = !lerDiscreta();
        try {
          /* 🔴 UM caractere. Nada que identifique quem esta do outro lado. */
          if (novo) {
            localStorage.setItem(CHAVE_DISCRETA, '1');
          } else {
            localStorage.removeItem(CHAVE_DISCRETA);
          }
        } catch (e) {
          /* Armazenamento bloqueado: o modo ainda vale nesta pagina, so nao
             sobrevive ao proximo clique. Melhor do que nao funcionar. */
        }
        window.tdDiscreet.aplicar(novo);
        document.querySelectorAll('[data-td-discreet]').forEach(function (b) {
          b.setAttribute('aria-pressed', novo ? 'true' : 'false');
        });
      });
    }

    /* ---------------------------------------------------------------- *
     * J5 — o fallback de prefetch no hover.
     *
     * 🔴 Ele SO existe para quem nao tem Speculation Rules. Rodar os dois
     * seria baixar a mesma pagina duas vezes — uma "otimizacao" que gasta a
     * franquia de dados da cliente e nao adianta nada.
     *
     * Regras, todas conservadoras:
     * - so link de produto e de colecao, do MESMO dominio;
     * - nada com `?` (o `/discount/`, o `?variant=` e o carrinho ficam de
     *   fora por construcao);
     * - cada endereco e buscado UMA vez por pagina;
     * - `pointerenter` cobre mouse e caneta; no celular o dedo nao dispara
     *   hover, e adiantar pagina em rede movel sem ela pedir e gastar dado
     *   dos outros.
     * ---------------------------------------------------------------- */
    function ligarPrefetch() {
      if (typeof HTMLScriptElement !== 'undefined' && HTMLScriptElement.supports) {
        if (HTMLScriptElement.supports('speculationrules')) return;
      }
      var raiz = document.querySelector('link[rel="canonical"]');
      if (!raiz) return;
      var vistos = {};

      document.addEventListener(
        'pointerenter',
        function (evento) {
          var alvo = evento.target;
          if (!alvo || !alvo.closest) return;
          var link = alvo.closest('a[href]');
          if (!link) return;
          if (link.origin !== window.location.origin) return;
          if (link.search) return;
          var caminho = link.pathname;
          if (caminho.indexOf('/products/') === -1) {
            if (caminho.indexOf('/collections/') === -1) return;
          }
          if (vistos[caminho]) return;
          vistos[caminho] = true;

          var tag = document.createElement('link');
          tag.rel = 'prefetch';
          tag.as = 'document';
          tag.href = link.href;
          document.head.appendChild(tag);
        },
        true
      );
    }

    function iniciar() {
      ligarDiscreta();
      ligarPrefetch();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar, { once: true });
    } else {
      iniciar();
    }

    /* O editor de temas recria o rodape a cada ajuste: sem isto, o botao do
       modo discreto voltaria a ficar escondido a partir do segundo ajuste. */
    document.addEventListener('shopify:section:load', ligarDiscreta);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  /*
   * B1 — o mega menu abre no HOVER com 120 ms de atraso e no FOCO por teclado.
   *
   * Por que 120 ms e não zero: sem atraso, atravessar o menu com o mouse para
   * chegar no carrinho abre e fecha os cinco painéis no caminho. O atraso é o
   * que separa "quis abrir" de "passou por cima".
   *
   * Por que delegação no documento e não um listener por <details>: o editor de
   * temas re-renderiza a seção a cada ajuste. Listener preso ao elemento morre
   * junto com ele, e a partir do segundo ajuste o hover para de funcionar sem
   * erro nenhum no console. Delegação sobrevive a qualquer re-render.
   *
   * Por que nada disso em touch: no celular o menu é a gaveta, e num aparelho
   * de toque o "hover" do navegador é o primeiro toque — o painel abriria e o
   * link não seria seguido. Só entra com ponteiro fino E acima de 990 px, que
   * é a mesma faixa em que o plano proíbe o hambúrguer.
   *
   * Sem biblioteca, sem framework: 3 ouvintes e um setTimeout.
   */
  (function () {
    var ATRASO = 120;
    var relogio = null;
    var aberto = null;
    var ponteiroFino = window.matchMedia('(hover: hover) and (pointer: fine)');
    var telaLarga = window.matchMedia('(min-width: 990px)');

    function podeHover() {
      return ponteiroFino.matches && telaLarga.matches;
    }

    function painel(alvo) {
      if (!alvo || !alvo.closest) return null;
      var d = alvo.closest('details.mega-menu');
      // Só os painéis do cabeçalho: um <details> de acordeão na página não é
      // menu, e abrir ele no hover seria surpresa desagradável.
      if (!d || !d.parentElement || d.parentElement.tagName !== 'HEADER-MENU') return null;
      return d;
    }

    function fecha(d) {
      if (!d) return;
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    }

    function abre(d) {
      if (!d || d.hasAttribute('open')) return;
      if (aberto && aberto !== d) fecha(aberto);
      d.setAttribute('open', '');
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'true');
    }

    // Quem manda no "quem está aberto" é o próprio evento toggle, e não o meu
    // controle: assim o clique nativo no summary e o hover continuam contando a
    // mesma história. `toggle` não borbulha, por isso a escuta é na captura.
    document.addEventListener(
      'toggle',
      function (e) {
        var d = e.target;
        if (!d || !d.matches || !d.matches('details.mega-menu')) return;
        if (d.open) {
          if (aberto && aberto !== d) fecha(aberto);
          aberto = d;
        } else if (aberto === d) {
          aberto = null;
        }
      },
      true
    );

    document.addEventListener('pointerover', function (e) {
      if (!podeHover()) return;
      if (e.pointerType && e.pointerType !== 'mouse') return;

      var d = painel(e.target);
      clearTimeout(relogio);

      if (d) {
        if (d === aberto) return;
        relogio = setTimeout(function () {
          abre(d);
        }, ATRASO);
      } else if (aberto && e.target.closest && !e.target.closest('.mega-menu__content')) {
        var saindo = aberto;
        relogio = setTimeout(function () {
          fecha(saindo);
        }, ATRASO);
      }
    });

    // Teclado: só com :focus-visible. Focar por clique já abriu pelo <details>;
    // reabrir aqui faria o clique parecer que não fechou.
    document.addEventListener('focusin', function (e) {
      var s = e.target && e.target.closest ? e.target.closest('summary') : null;
      if (!s) return;
      var d = painel(s);
      if (!d) return;
      try {
        if (!s.matches(':focus-visible')) return;
      } catch (erro) {
        return;
      }
      abre(d);
    });

    // Esc fecha e devolve o foco ao item do menu — o <details> não faz isso
    // sozinho, e sem devolver o foco a cliente de teclado fica perdida no meio
    // da página.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      // 🔴 Cancelar o relógio ANTES de fechar. Sem isso, um timer de hover que
      // já estava a caminho abre o painel logo depois de a pessoa ter mandado
      // fechar — e a impressão é de que o Esc não funciona.
      clearTimeout(relogio);
      if (!aberto) return;
      var s = aberto.querySelector('summary');
      fecha(aberto);
      if (s) s.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
